#import "../../common/graphql/ExtractionTypes.graphql"
query PayCycleAvailableDocumentTypes {
  payCycleAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      ...ExtractionTypes
    }
  }
}
